import { Component, Input } from '@angular/core';
@Component({
	selector: 'app-folha-de-pagamento-tab',
  	templateUrl: './tab.component.html',
  	styleUrls: ['./tab.component.scss']
})
export class FolhaDePagamentoTabComponent{
	@Input() desativado:boolean = false;;
}
